/**
 * @file DialogCrear.js
 * @brief Componente para crear una especialidad donde se solicita el nombre de la especialidad y la cantidad de consultas
 * @requires React
 * 
 * 
 * {
    "nombre" : "doctor",
    "correo" : "doctor",
    "password" : "123456",
    "rol" : "Triage",
    "especialidad" : "67db87ef4a717fc025a5e055"
  }
 */

import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, MenuItem } from '@mui/material';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import { USER_TYPES } from '../../../constants/userTypes';

const DialogCrearUsuario = ({ open, handleClose, handleCrear, especialidades }) => {

  const formik = useFormik({
    initialValues: {
      nombre: '',
      correo: '',
      password: '',
      rol: '',
      especialidad: '',
    },
    onSubmit: (values) => {
      handleCrear(values);
    },
  });

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '10px',
        }
      }}
    >
      <DialogTitle>Crear usuario</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          <TextField
            label='Nombre'
            variant='outlined'
            value={formik.values.nombre}
            onChange={(formik.handleChange('nombre'))}
            error={formik.touched.nombre && Boolean(formik.errors.nombre)}
            helperText={formik.touched.nombre && formik.errors.nombre}
            onBlur={formik.handleBlur('nombre')}
          />
          <TextField
            label='Correo'
            variant='outlined'
            value={formik.values.correo}
            onChange={(formik.handleChange('correo'))}
            error={formik.touched.correo && Boolean(formik.errors.correo)}
            helperText={formik.touched.correo && formik.errors.correo}
            onBlur={formik.handleBlur('correo')}
          />
          <TextField
            label='Password'
            variant='outlined'
            value={formik.values.password}
            onChange={(formik.handleChange('password'))}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            onBlur={formik.handleBlur('password')}
          />
          <TextField
            label='Rol'
            variant='outlined'
            value={formik.values.rol}
            onChange={(formik.handleChange('rol'))}
            error={formik.touched.rol && Boolean(formik.errors.rol)}
            helperText={formik.touched.rol && formik.errors.rol}
            onBlur={formik.handleBlur('rol')}
            select
          >
            {
              USER_TYPES?.map((rol) => (
                <MenuItem key={rol.value} value={rol.value}>
                  {rol.text}
                </MenuItem>
              ))
            }
          </TextField>
          {
            formik.values.rol === 'Doctor' && (
              <TextField
                label='Especialidad'
                variant='outlined'
                value={formik.values.especialidad}
                onChange={(formik.handleChange('especialidad'))}
                error={formik.touched.especialidad && Boolean(formik.errors.especialidad)}
                helperText={formik.touched.especialidad && formik.errors.especialidad}
                onBlur={formik.handleBlur('especialidad')}
                select
              >
                {
                  especialidades?.map((especialidad) => (
                    <MenuItem key={especialidad.id} value={especialidad.id}>
                      {especialidad.nombre}
                    </MenuItem>
                  ))
                }
              </TextField>
            )
          }
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button
          variant='contained'
          color='primary'
          type='submit'
          onClick={formik.handleSubmit}
        >
          Crear
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogCrearUsuario;